import React, { Component} from 'react';
import ReactGA from 'react-ga4';
import {Link} from 'react-router-dom';
import HelpAndCurrency from './help-and-currency.js';
import AboutLinks from './footer-links/about-links.js';
import * as Utilities from './utilities.js';


class Product extends Component {
  constructor(props) {
    super(props);
    this.sessionTs = Date.now();
    this.state = {
      products: [],
	  addedToCart: null,
	  qty: null,
	  seo_json: 1,
	  admin: false,
	  aiEnabled: false,
	  aiToggleMessage: null,
	  productData: null,
	  productSections: null,
	  relatedItemsSection: null,
	  accessoriesSection: null,
	  productIcon: null,
	  productImages: [],
	  activeImageIndex: 0,
	  imagesGenerating: false,
	  imagesError: null,
	  imageUploading: false,
	  isDragOver: false,
	  descGenerating: false,
	  sharingFilename: null,
	  shareTargetId: '',
	  shareStatus: null,
	  categoryData: null,
    };
	this.toggleAiListing = this.toggleAiListing.bind(this);
	this.handleInputChange = this.handleInputChange.bind(this);
	this.setActiveImage = this.setActiveImage.bind(this);
	this.approveImage = this.approveImage.bind(this);
	this.removeImage = this.removeImage.bind(this);
	this.generateImages = this.generateImages.bind(this);
	this.handleDrop = this.handleDrop.bind(this);
	this.uploadImage = this.uploadImage.bind(this);
	this.generateDescription = this.generateDescription.bind(this);
	this.shareImage = this.shareImage.bind(this);
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
 putInCart(prodID, qty, e){
	if(qty == null) {
		qty=1
	}
	var url = Utilities.getApiURL('cart.php', '?id='+prodID+'&qty='+qty);
	fetch(url, {
		method: 'PUT',
		credentials: 'include'
	}).then(results => {
      return results.json();
    }).then((data) => {
		var cartSuccess  = false;
		data.product.map((prod) => {
			if(prod.prodID === Utilities.getUrlParam('id')) {
				cartSuccess = true;
			}
		})
		var addedToCart = "There was an issue adding this item to your cart.  Please try again."
		if(cartSuccess === true) {
			var addedToCart = "This item was added to your cart.";
			Utilities.gaEvent(ReactGA, 'add_to_cart', {
				currency: 'USD',
				value: parseFloat(this.state.productData?.prodPrice) || 0,
				items: [{
					item_id: String(prodID),
					item_name: this.state.productData?.prodName || '',
					item_brand: this.state.productData?.brandName || '',
					price: parseFloat(this.state.productData?.prodPrice) || 0,
					quantity: parseInt(qty) || 1
				}]
			});
		}
		this.setState({addedToCart: addedToCart});
    })
}
close_modal(){
	  const modal = document.getElementById("myModal");
	  modal.style.display = "none";
}
base64PDFToBlobUrl( base64 ) {
      const binStr = atob( base64 );
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt( i );
      }
      const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
      const url = URL.createObjectURL( blob );
      return url;
}
showPdfModal(file_id){
	Utilities.gaEvent(ReactGA, 'file_download', { file_id: String(file_id) });
    var url = Utilities.getApiURL('get_pdf.php', '?id='+file_id);
	fetch(url, {
		method: 'GET',
		credentials: 'include'
	}).then(results => {
      return results.json();
    }).then((data) => {
		var pdf_blob  = null;
		data.file.map((file) => {
		    var pdf_file = this.base64PDFToBlobUrl(file.file_contents);
		    document.getElementById('pdf_modal').src=pdf_file;
		})
	})
	

	
	// Get the modal
	const modal = document.getElementById("myModal");

	// Get the <span> element that closes the modal
	const span = document.getElementsByClassName("close")[0];
    //document.getElementById('pdf_modal').data = file;
    //display the modal
    modal.style.display = "block";

	// When the user clicks on <span> (x), close the modal
	span.onclick = function() {
	  modal.style.display = "none";
	}

	// When the user clicks anywhere outside of the modal, close it
	window.onclick = function(event) {
	  if (event.target == modal) {
		modal.style.display = "none";

	  }
	}	  
}
  toggleAiListing() {
	var newVal = this.state.aiEnabled ? 0 : 1;
	var url = Utilities.getApiURL('product.php', '?id=' + Utilities.getUrlParam('id') + '&ai=' + newVal + '&desc_update=true');
	fetch(url, {
		method: 'GET',
		credentials: 'include'
	}).then(results => {
		return results.json();
	}).then(data => {
		this.setState({aiEnabled: newVal === 1, aiToggleMessage: 'AI listing ' + (newVal === 1 ? 'enabled' : 'disabled') + '.'});
		setTimeout(() => this.setState({aiToggleMessage: null}), 3000);
	}).catch(err => {
		this.setState({aiToggleMessage: 'Update failed. Please try again.'});
	});
  }

  generateDescription() {
	var hasExisting = this.state.productData && this.state.productData.ai_desc;
	if (hasExisting && !window.confirm('This product already has an enhanced description. Regenerate and overwrite it?')) {
		return;
	}
	this.setState({descGenerating: true});
	var url = Utilities.getApiURL('generate_product_listing.php', '?prod_id=' + Utilities.getUrlParam('id'));
	fetch(url, {method: 'GET', credentials: 'include'})
		.then(r => r.json())
		.then(data => {
			if (data.success) {
				this.setState(prev => ({
					descGenerating: false,
					productData: {
						...prev.productData,
						ai_desc: data.ai_desc,
						ai_long_desc: typeof data.ai_long_desc === 'object'
							? JSON.stringify(data.ai_long_desc)
							: data.ai_long_desc,
						ai_keys: data.ai_keys,
					}
				}));
			} else {
				alert('Generation failed: ' + (data.error || 'Unknown error'));
				this.setState({descGenerating: false});
			}
		})
		.catch(() => {
			alert('Generation failed. Please try again.');
			this.setState({descGenerating: false});
		});
  }

  setActiveImage(idx) {
	this.setState({activeImageIndex: idx});
  }

  approveImage(filename, approved) {
	var url = Utilities.getApiURL('approve_product_image.php',
		'?prod_id=' + Utilities.getUrlParam('id') +
		'&filename=' + encodeURIComponent(filename) +
		'&approved=' + (approved ? 1 : 0));
	fetch(url, {method: 'GET', credentials: 'include'})
		.then(r => r.json())
		.then(data => {
			if (data.success) {
				var updated = this.state.productImages.map(img =>
					img.filename === filename ? {...img, approved: approved} : img
				);
				this.setState({productImages: updated, activeImageIndex: this.state.activeImageIndex});
			}
		});
  }

  removeImage(filename) {
	var url = Utilities.getApiURL('remove_product_image.php',
		'?prod_id=' + Utilities.getUrlParam('id') +
		'&filename=' + encodeURIComponent(filename));
	fetch(url, {method: 'GET', credentials: 'include'})
		.then(r => r.json())
		.then(data => {
			if (data.success) {
				var updated = this.state.productImages.filter(img => img.filename !== filename);
				var newIdx = Math.min(this.state.activeImageIndex, updated.length);
				this.setState({productImages: updated, activeImageIndex: newIdx});
			}
		});
  }

  generateImages() {
	this.setState({imagesGenerating: true, imagesError: null, productImages: [], activeImageIndex: 0});
	var url = Utilities.getApiURL('generate_product_images.php', '?prod_id=' + Utilities.getUrlParam('id'));
	fetch(url, {method: 'GET', credentials: 'include'})
		.then(r => r.json())
		.then(data => {
			if (data.images) {
				this.setState({productImages: data.images, imagesGenerating: false, activeImageIndex: 0});
			} else {
				this.setState({imagesGenerating: false, imagesError: data.error || 'Image generation failed.'});
			}
		})
		.catch(() => this.setState({imagesGenerating: false, imagesError: 'Image generation failed. Please try again.'}));
  }

  handleDrop(e) {
	e.preventDefault();
	this.setState({isDragOver: false});

	// File dragged from the filesystem
	const file = e.dataTransfer.files[0];
	if (file && file.type.startsWith('image/')) {
		this.uploadImage(file);
		return;
	}

	// Image dragged from another browser tab — browsers pass a URL
	const uri = e.dataTransfer.getData('text/uri-list') || e.dataTransfer.getData('text/plain');
	if (uri && uri.trim().match(/^https?:\/\//i)) {
		this.uploadImage(uri.trim());
		return;
	}

	this.setState({imagesError: 'Please drop an image file or drag an image from another tab.'});
  }

  uploadImage(source) {
	this.setState({imageUploading: true, imagesError: null});
	const formData = new FormData();
	formData.append('prod_id', Utilities.getUrlParam('id'));
	if (typeof source === 'string') {
		formData.append('image_url', source);
	} else {
		formData.append('image', source);
	}
	const url = Utilities.getApiURL('upload_product_image.php', '');
	fetch(url, {method: 'POST', credentials: 'include', body: formData})
		.then(r => r.json())
		.then(data => {
			if (data.image) {
				this.setState(prev => ({
					productImages: [...prev.productImages, data.image],
					imageUploading: false,
					activeImageIndex: prev.productImages.length,
				}));
			} else {
				this.setState({imageUploading: false, imagesError: data.error || 'Upload failed.'});
			}
		})
		.catch(() => this.setState({imageUploading: false, imagesError: 'Upload failed. Please try again.'}));
  }

  shareImage(filename) {
	  const targetId = parseInt(this.state.shareTargetId, 10);
	  if (!targetId) return;
	  const sourceProdId = Utilities.getUrlParam('id');
	  var url = Utilities.getApiURL('share_product_image.php',
		  '?source_prod_id=' + sourceProdId +
		  '&target_prod_id=' + targetId +
		  '&filename=' + encodeURIComponent(filename));
	  fetch(url, {method: 'GET', credentials: 'include'})
		  .then(r => r.json())
		  .then(data => {
			  if (data.success) {
				  this.setState({sharingFilename: null, shareTargetId: '', shareStatus: {filename, success: true, message: 'Shared to product #' + targetId}});
			  } else {
				  this.setState({shareStatus: {filename, success: false, message: data.error || 'Share failed'}});
			  }
		  })
		  .catch(() => this.setState({shareStatus: {filename, success: false, message: 'Network error'}}));
  }

  renderBreadcrumb() {
    const {categoryData, productData} = this.state;
    const cats = categoryData && categoryData[0] && categoryData[0].parent_category;
    const crumbs = cats ? [...cats].reverse() : [];
    return (
      <nav className="product-breadcrumb" aria-label="breadcrumb">
        <a href="/">Home</a>
        {crumbs.map(cat => (
          <span key={cat.id}>
            <span className="product-breadcrumb-sep">›</span>
            <a href={'/category?id=' + cat.id + '&n=' + encodeURIComponent(cat.url_name)}>{cat.name}</a>
          </span>
        ))}
        {productData && (
          <span>
            <span className="product-breadcrumb-sep">›</span>
            <span className="product-breadcrumb-current">{productData.prodName}</span>
          </span>
        )}
      </nav>
    );
  }

  renderCarousel() {
	const {productIcon, productImages, activeImageIndex, admin, aiEnabled, imagesGenerating, imagesError, imageUploading, isDragOver, sharingFilename, shareTargetId, shareStatus} = this.state;
	if (!productIcon) return null;

	const publicBase = Utilities.getPublicBaseURL();
	const iconSlide = {url: productIcon, isIcon: true, approved: true, filename: null};
	const imgUrl = (path) => publicBase + path + '?v=' + this.sessionTs;

	let slides;
	if (admin) {
		slides = [iconSlide, ...productImages.map(img => ({...img, url: imgUrl(img.path), isIcon: false}))];
	} else if (productImages.some(img => img.approved)) {
		slides = [iconSlide, ...productImages.filter(img => img.approved).map(img => ({...img, url: imgUrl(img.path), isIcon: false}))];
	} else {
		return <img src={productIcon} alt="product" style={{maxWidth:'100%', display:'block'}} />;
	}

	const activeIdx = Math.min(activeImageIndex, slides.length - 1);
	const current = slides[activeIdx];

	return (
		<div className="product-carousel">
			<div className="product-carousel-main">
				<img src={current.url} alt="product" />
				{admin && !current.isIcon && (
					<div className={'product-carousel-badge ' + (current.approved ? 'badge-approved' : 'badge-pending')}>
						{current.approved ? 'Approved' : 'Pending Approval'}
					</div>
				)}
			</div>
			{admin && !current.isIcon && (
				<div className="product-carousel-actions">
					<button
						className={'btn ' + (current.approved ? 'btn-danger' : 'btn-success')}
						onClick={() => this.approveImage(current.filename, !current.approved)}
					>
						{current.approved ? 'Revoke Approval' : 'Approve Image'}
					</button>
					<button
						className="btn btn-secondary"
						style={{marginLeft: '8px'}}
						onClick={() => this.removeImage(current.filename)}
					>
						Remove
					</button>
					<button
						className="btn btn-outline-secondary"
						style={{marginLeft: '8px'}}
						onClick={() => this.setState(sharingFilename === current.filename
							? {sharingFilename: null, shareTargetId: '', shareStatus: null}
							: {sharingFilename: current.filename, shareTargetId: '', shareStatus: null})}
					>
						Share
					</button>
					{sharingFilename === current.filename && (
						<div style={{display:'flex', alignItems:'center', marginTop:'8px', gap:'6px'}}>
							<input
								type="number"
								placeholder="Product ID"
								value={shareTargetId}
								onChange={e => this.setState({shareTargetId: e.target.value, shareStatus: null})}
								style={{width:'110px', padding:'4px 8px', fontSize:'13px'}}
							/>
							<button
								className="btn btn-primary"
								style={{fontSize:'13px', padding:'4px 10px'}}
								onClick={() => this.shareImage(current.filename)}
								disabled={!shareTargetId}
							>
								Confirm
							</button>
							{shareStatus && shareStatus.filename === current.filename && (
								<span style={{fontSize:'13px', color: shareStatus.success ? '#16a34a' : '#dc2626'}}>
									{shareStatus.message}
								</span>
							)}
						</div>
					)}
				</div>
			)}
			{slides.length > 1 && (
				<div className="product-carousel-thumbs">
					{slides.map((slide, idx) => (
						<img
							key={idx}
							src={slide.url}
							alt={'slide ' + idx}
							onClick={() => this.setActiveImage(idx)}
							className={
								'product-carousel-thumb' +
								(idx === activeIdx ? ' thumb-active' : '') +
								(admin && !slide.isIcon && slide.approved ? ' thumb-approved' : '') +
								(admin && !slide.isIcon && !slide.approved ? ' thumb-pending' : '')
							}
						/>
					))}
				</div>
			)}
			{admin && (
				<div className="product-carousel-generate">
					<div
						onDragOver={e => { e.preventDefault(); this.setState({isDragOver: true}); }}
						onDragEnter={e => { e.preventDefault(); this.setState({isDragOver: true}); }}
						onDragLeave={() => this.setState({isDragOver: false})}
						onDrop={this.handleDrop}
						style={{
							border: '2px dashed ' + (isDragOver ? '#3b82f6' : '#d1d5db'),
							borderRadius: '4px',
							padding: '12px',
							textAlign: 'center',
							fontSize: '13px',
							color: isDragOver ? '#3b82f6' : '#9ca3af',
							background: isDragOver ? '#eff6ff' : 'transparent',
							marginBottom: '8px',
							transition: 'all 0.15s',
						}}
					>
						{imageUploading ? 'Uploading…' : 'Drop an image here to add it'}
					</div>
					<button
						className="btn btn-primary"
						onClick={this.generateImages}
						disabled={imagesGenerating || imageUploading}
					>
						{imagesGenerating ? 'Generating...' : 'Generate AI Images'}
					</button>
					{imagesGenerating && <span style={{marginLeft:'10px',fontSize:'13px',color:'#6b7280'}}>This may take a minute…</span>}
					{imagesError && <div style={{marginTop:'8px',fontSize:'13px',color:'#dc2626'}}>{imagesError}</div>}
				</div>
			)}
		</div>
	);
  }

  renderAiLongDesc(jsonStr) {
    if (!jsonStr) return null;
    let parsed;
    try {
      parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr;
    } catch(e) {
      return <p style={{color:'red'}}>Invalid JSON in ai_long_desc</p>;
    }
    if (!parsed || !parsed.sections) return null;
    return parsed.sections.map((section, idx) => {
      if (section.type === 'paragraph') {
        return <p key={idx}>{section.content}</p>;
      }
      if (section.type === 'list') {
        return (
          <div key={idx} style={{marginBottom:'10px'}}>
            <strong>{section.heading}</strong>
            <ul>
              {section.items.map((item, j) => <li key={j}>{item}</li>)}
            </ul>
          </div>
        );
      }
      if (section.type === 'tags') {
        return (
          <div key={idx} style={{display:'flex',flexWrap:'wrap',gap:'6px',margin:'8px 0'}}>
            {section.items.map((tag, j) => (
              <span key={j} style={{background:'#e8f4f8',border:'1px solid #b8d4e3',borderRadius:'4px',padding:'2px 8px',fontSize:'12px'}}>{tag}</span>
            ))}
          </div>
        );
      }
      return null;
    });
  }

  componentDidMount() {
	  var ga = Utilities.gaInitialize(ReactGA);
	  Utilities.gaPageView(ga, "msa_page_view", "/product?id="+Utilities.getUrlParam('id'), "Products: "+Utilities.getUrlParam('n'));
	var productUrl = "product?id=";
	var url = Utilities.getApiURL('product.php', '?id='+Utilities.getUrlParam('id'));
    fetch(url, {method: 'GET', credentials: 'include'})
    .then(results => {
      return results.json();
    }).then(data => {
      var admin = data.admin;
      var aiEnabled = false;
      var picData = null;
      var picSections = null;
      var productIcon = null;
      var parsedImages = [];
      var outerRelatedItemsSection = null;
      var outerAccessoriesSection = null;
      let products = data.product.map((pic) => {
        console.log(pic);
        
        //set page title
        document.title = pic.brandName+" "+pic.prodName+" SKU: "+pic.prodSku;
        
        //Set canonical link       
        document.getElementById('link_canonical').href = 'https://www.msaironline.com/product?id='+Utilities.getUrlParam('id')+'&n='+pic.urlName;


        //Set product meta keywords
        var meta = document.getElementById('meta_keywords');
        meta.setAttribute('name', 'keywords');
        meta.setAttribute('content', pic.ai_keys || pic.prodSearchKey);

        //Set product meta description
        var meta = document.getElementById('meta_description');
        meta.setAttribute('name', 'description');
        meta.setAttribute('content', pic.ai_desc || pic.brandName+" "+pic.prodName+" "+pic.prodSku+" | "+pic.category_name+" | "+pic.prodDesc);

        //Set SEO JSON
        var seoImages = [];
        try { seoImages = pic.images_json ? JSON.parse(pic.images_json) : []; } catch(e) {}
        var firstApprovedImage = seoImages.find(img => img.approved);
        var seoImageUrl = firstApprovedImage ? Utilities.getPublicBaseURL() + firstApprovedImage.path : pic.icon;
        var seo_json = '{'+
            '"@context": "https://schema.org/",'+
            '"@type": "Product",'+
            '"name": "'+pic.brandName+' '+pic.prodName+' '+pic.prodSku+'",'+
            '"image": "'+seoImageUrl+'",'+
            '"description": "'+(pic.ai_desc || pic.prodDesc)+'",'+
            '"sku": "'+pic.prodSku+'",'+
            '"brand": {'+
              '"@type": "Brand",'+
              '"name": "'+pic.brandName+'"'+
            '},'+
            '"offers": {'+
              '"@type": "Offer",'+
              '"priceCurrency": "USD",'+
              '"price": "'+pic.prodPrice+'",'+
              '"availability": "https://schema.org/InStock",'+
              '"url": "'+pic.canonical_url+'"'+
            '}'+
          '}';
        this.setState({seo_json: seo_json});
        
        //Set meta OG fields  
        var meta = document.getElementById('og_title');
        meta.setAttribute('content', pic.brandName+' '+pic.prodName+' '+pic.prodSku);       
        var meta = document.getElementById('og_description');
        meta.setAttribute('content', pic.ai_desc || pic.prodDesc);
        var meta = document.getElementById('og_image');
        meta.setAttribute('content', pic.icon); 
        var meta = document.getElementById('og_url');
        meta.setAttribute('content', pic.canonical_utitlerl); 
        var meta = document.getElementById('og_type');
        meta.setAttribute('content', 'product'); 
        
		var prodAttributes = null;
		if(pic.attributes) {
			prodAttributes = pic.attributes.map((attribute) => {
            return (
              <div key="attribute-details">
                <li><strong>{attribute.field}</strong>: {attribute.value}</li>
              </div>
            )
        });}

		var message = null;
		if(pic.message){
			message = (pic.message)
		}
		if(pic.related_parts){
			var relatedItems = null;
			var relatedItemsSection = null;
			relatedItems = pic.related_parts.map((rp) => {
            return (
				<div className="replacement_item_listing">
						<div className="replacement_item_entry">
							<div className="replacement_item_image">
								<img style={{width:'100%'}} src={rp.icon} alt={rp.name}></img>
							</div>
							<div className="replacement_item_details">
								<h6 className="replacement_item_title"><a href={productUrl+rp.accessory_prod_id}>{rp.name}</a></h6>
								<h6 className="replacement_item_brand_name">{pic.brandName}</h6>
								<h6 className="replacement_item_actual_price"><strong>${rp.prodPrice}</strong></h6>
							</div>
						</div>
				</div>
			)});
			relatedItemsSection = (
			    <div id="replacement_items_section">
					  <h4 className="replacement_items_header">Related Parts</h4>
					  <div className="related-items-scroll">{relatedItems}</div>
				  </div>)
			outerRelatedItemsSection = relatedItemsSection;
		}
		var replacementParts = null;
		var replacementPartsSection = null;
		var replacement_part_image = null;
		if(pic.replacement_part_image)
			replacement_part_image = (					
					<div className="replacement_parts_image">
						<img src={pic.replacement_part_image}></img>
					</div>)
		if(pic.replacement_parts){
			replacementParts = pic.replacement_parts.map((rp) => {
			var image_num = null;
			if(rp.image_num > 0)
				image_num = (<h4 className="replacement_parts_price">{rp.image_num}</h4>)
            return (
				<span className="replacement_parts_detail">
				{image_num}
					<div className="replacement_parts_thumbnail">
						<img src={rp.icon} alt={rp.name}></img>
					</div>

                    <div>
					    <h4 className="replacement_parts_name"><a href={productUrl+rp.replacement_prod_id+'&'+rp.urlName+'&l=replacement_parts'}>{rp.name}</a></h4>
					    <h4 className="replacement_parts_price"><strong>Price</strong>: {rp.prodPrice}</h4>
					
						{/*<form >
					<div className="replacement-parts-quantity-input-group">
							<strong>Quantity</strong>:
							<input id='qty' type="number" className="quantityBox" value="0" />
							<input id="prodID" value={rp.prodPrice} />
					</div>
					<div className="replacement-parts-add-to-cart">
						<input onclick="myFunction()" type="submit" value="Add To Cart" />
					</div>
						</form>*/}
					</div>
					<div>
					    <button className="btn btn-primary" onClick={(e) => this.putInCart(rp.prodID, this.state.qty, e)}><h4 className="replacement_parts_price">Add To Cart</h4></button>
					</div>
				</span>
            )});
			replacementPartsSection = (
				
				<div className="replacement_parts_section">
					<h2 className="replacement_parts_header">Replacement Parts</h2>
					{replacement_part_image}
					{replacementParts}
				</div>)
		}
		if(pic.accessories){
			var accessories = null;
			var accessoriesSection = null;
			relatedItems = pic.accessories.map((accessory) => {
            return (
				<div key="item-page" className="replacement_item_listing">
						<div className="replacement_item_entry">
							<div className="replacement_item_image">
								<img src={accessory.icon} alt={accessory.name}></img>
							</div>
							<div className="replacement_item_details">
								<h6 className="replacement_item_title"><a href={productUrl+accessory.related_prod_id}>{accessory.name}</a></h6>
								<h6 className="replacement_item_brand_name">{accessory.brandName}</h6>
								<h6 className="replacement_item_actual_price"><strong>{accessory.prodPrice}</strong></h6>
							</div>
						</div>
				</div>
			)});
			accessoriesSection = (
			    <div id="replacement_items_section">
					<h4 className="replacement_items_header">Accessories</h4>
					<div className="related-items-scroll">{relatedItems}</div>
				</div>)
			outerAccessoriesSection = accessoriesSection;
		}
		var compatibleParts = null;
		var compatiblePartsSection = null;
		if(pic.compatible_equipment){
			compatibleParts = pic.compatible_equipment.map((rp) => {
            return (
				<span className="replacement_parts_detail">
          {/* <img src={rp.icon} alt={rp.name}></img> */}
					<h4 className="replacement_parts_name"><a href={productUrl+rp.compatible_prod_id}>{rp.name}</a></h4>
				</span>
            )});
			compatiblePartsSection = (
				<div className="replacement_parts_section">
					<h2 className="replacement_parts_header">Compatible Parts</h2>
					{compatibleParts}
				</div>)
		}
		var productFiles = null;
		var productFilesSection = null;
		if(pic.file){
			productFiles = pic.file.map((rp) => {
            return (
				<div key="indiv-item" className="product-file">
					<div className="product-file-details">
					    <a data-turbolinks="false" onClick ={(e) => this.showPdfModal(rp.file_id, e)} >
					        <img src="http://www.msaironline.com/images/pdf.jpg" alt="pdf-icon"></img> 
					        {rp.file_name}
					    </a>
					</div>
				</div>
            )});
			productFilesSection = (
				<div className="file_section">
					{productFiles}
				</div>)
		}
		//comment to change files a bit
		var enabled = pic.enabled === '1' || pic.enabled === 1 || pic.enabled === true;
		aiEnabled = enabled;
		picData = {ai_desc: pic.ai_desc, ai_long_desc: pic.ai_long_desc, ai_keys: pic.ai_keys, image_filename: pic.image_filename, image_alt_text: pic.image_alt_text, prodDesc: pic.prodDesc, prodLongDesc: pic.prodLongDesc, prodName: pic.prodName, brandName: pic.brandName, prodPrice: pic.prodPrice, prodSku: pic.prodSku};
		Utilities.gaEvent(ReactGA, 'view_item', {
			currency: 'USD',
			value: parseFloat(pic.prodPrice) || 0,
			items: [{
				item_id: String(pic.prodSku),
				item_name: pic.prodName,
				item_brand: pic.brandName,
				price: parseFloat(pic.prodPrice) || 0,
				quantity: 1
			}]
		});
		try { parsedImages = pic.images_json ? JSON.parse(pic.images_json) : []; } catch(e) {}
		productIcon = pic.icon || null;
		var savings = (pic.msrp - pic.prodPrice).toFixed(2);
		var cost_row = null;
		if(admin === true) {
		    var cost = (pic.msrp * (1-(pic.cost_percentage_discount/100))).toFixed(2);
		    var profit = (pic.prodPrice-cost).toFixed(2);
		    var margin = ((profit / pic.prodPrice)*100).toFixed(2);;
		    cost_row = (
		                <>
		                <h4 className="individual-product-actual-cost">Our Cost: <strong>${cost}</strong></h4>
		                <h4 className="individual-product-actual-profit">Profit: <strong>${profit}</strong></h4>
		                <h4 className="individual-product-actual-margin">Margin: <strong>{margin}%</strong></h4>
		                </>
		                )
		}
		
		var picSections = (
		  <div className="enhanced_listing_section">
		    <div className="individual-product-description">
		      <ul>
		        {prodAttributes}
		        <li dangerouslySetInnerHTML={{__html: message}} />
		      </ul>
		    </div>
		    <div style={{clear:'both'}} />
		    {productFilesSection}
		    <div style={{clear:'both'}} />
		    {replacementPartsSection}
		    <div style={{clear:'both'}} />
		    {compatiblePartsSection}
		  </div>
		);
		this.setState({productSections: picSections});
		
        return(

          <div key={pic.results}>

              <div className="content-area-container2">
                <div id="individual_product_page">
                  <div className="individual-product">

                    <div className="individual_product_listing">
                      <div className="individual_product_entry">
                        {pic.product}
                      </div>


                    <div className="individual-product-details">
                      <div className="product-title">
                        <h1 className="individual-product-title2">{pic.brandName} {pic.prodName} {pic.prodSku}</h1>
                      </div>
						<h4>Catalog Number: {pic.prodSku}</h4>
                        <h4 className="product-brand-title"><img src={pic.brandIcon} alt={pic.brandName}/></h4>
                        <h4 className="individual-product-suggested-retail-price">MSRP: ${pic.msrp}</h4>
                        <h4 className="individual-product-savings">Savings: <strong>${savings}</strong></h4>
                        <h4 className="individual-product-actual-price">Price: <strong>${pic.prodPrice}</strong></h4>
                        {cost_row}
                        <br />
                        <br />
					  </div>
                    
                  </div>
                </div>

        </div>


          <div id="quantity-input-group">
            Qty:
            <input name='qty' type="text" className="quantityBox" value={this.state.qty} defaultValue="1" size="2" maxLength="4" onChange={this.handleInputChange} />
			<div id="add-to-cart">
				<button className="btn btn-primary" onClick={(e) => this.putInCart(pic.prodID, this.state.qty, e)}><h4>Add To Cart</h4></button>
			</div>
		  </div>
		  
		  
	

      </div>






    </div>




        )
      })
      console.log("state", this.state.products);
      this.setState({products: products, admin: admin, aiEnabled: aiEnabled, productData: picData, productSections: picSections, relatedItemsSection: outerRelatedItemsSection, accessoriesSection: outerAccessoriesSection, productIcon: productIcon, productImages: parsedImages, categoryData: data.category});
    })
  }




  render() {
    return (

      <div className="container2">
        <div className="container1">
		   <div className="content-area-container">
            {this.renderBreadcrumb()}
            {this.renderCarousel()}
            {this.state.products}
            <div className="cartNotification">{this.state.addedToCart}</div>
            {!this.state.aiEnabled && this.state.productData && (
              <div className="enhanced_listing_section">
                <p dangerouslySetInnerHTML={{__html: this.state.productData.prodDesc}} />
                <p dangerouslySetInnerHTML={{__html: this.state.productData.prodLongDesc}} />
              </div>
            )}
            {(this.state.admin || this.state.aiEnabled) && this.state.productData && (
              <div className={'enhanced_listing_section' + (this.state.admin && !this.state.aiEnabled ? ' enhanced_listing_section_disabled' : '')}>
                <p>{this.state.productData.ai_desc}</p>
                {this.renderAiLongDesc(this.state.productData.ai_long_desc)}
              </div>
            )}
            
            {this.state.productSections}
            {this.state.relatedItemsSection}
            {this.state.accessoriesSection}




{this.state.admin && (
              <div style={{background:'#1e3a5f',color:'#fff',borderRadius:'8px',padding:'12px 20px',margin:'0 0 16px 0',display:'flex',alignItems:'center',gap:'16px',flexWrap:'wrap'}}>
                <strong style={{fontSize:'14px'}}>Admin:</strong>
                <span style={{fontSize:'14px'}}>AI Enhanced Listing: <strong>{this.state.aiEnabled ? 'Enabled' : 'Disabled'}</strong></span>
                <button
                  onClick={this.toggleAiListing}
                  style={{background: this.state.aiEnabled ? '#dc2626' : '#16a34a', color:'#fff', border:'none', borderRadius:'6px', padding:'6px 16px', cursor:'pointer', fontWeight:'bold', fontSize:'14px'}}
                >
                  {this.state.aiEnabled ? 'Disable AI Listing' : 'Enable AI Listing'}
                </button>
                {this.state.aiToggleMessage && (
                  <span style={{fontSize:'13px',background:'rgba(255,255,255,0.15)',padding:'4px 10px',borderRadius:'4px'}}>{this.state.aiToggleMessage}</span>
                )}
                <button
                  onClick={this.generateDescription}
                  disabled={this.state.descGenerating}
                  style={{background:'#7c3aed',color:'#fff',border:'none',borderRadius:'6px',padding:'6px 16px',cursor:'pointer',fontWeight:'bold',fontSize:'14px',opacity: this.state.descGenerating ? 0.7 : 1}}
                >
                  {this.state.descGenerating ? 'Generating...' : 'Generate Description'}
                </button>
              </div>
            )}
				<div className="FooterLinks1">
				</div>

				<div className="FooterLinks2">
					<AboutLinks />
				</div>
			</div>
		    <div className="about-footer">
				<div className="terms">
					<p><a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> | <a href="/privacy" target='_blank' rel="noopener noreferrer">Privacy Policy</a></p>
				</div>

			<div className="copyright">
				<p>&copy; {new Date().getFullYear()} - MS Air, Inc. | <Link to="/">Home</Link></p>
			</div>

      </div>
        </div>
        
        <dialog  id="myModal" class="modal">
                    <p><span class="close">&times;</span></p>
	                <embed class='embedPdfModal' id='pdf_modal' src=''  type="application/pdf"></embed>
		            <p><button onClick={(e) => this.close_modal()}>Close</button></p>
        </dialog>

      <script type="application/ld+json" id="seo_json">{this.state.seo_json}</script>
      </div>
      
    )
  }





}



export default Product;
